import { useTranslation } from 'react-i18next';
import { Box, Grid, SxProps } from '@mui/material';
import { Body, H6 } from '../Typography';
import { shadows } from '../../lightTheme';
import FamiliplusLongVersion from '../../images/FamiliplusLongVersion.svg';

const FamiliplusProfileCard = (props: { numberOfPoints: number; valueOfPoints: number; sx?: SxProps }): JSX.Element => {
  const { t } = useTranslation('familiplusPage');
  const pointsValue = (Math.round(props.valueOfPoints * 100) / 100).toFixed(2);

  return (
    <Box
      id="familiplusProfileCard"
      sx={{
        position: 'relative',
        background: 'radial-gradient(50% 50% at 50% 50%, #FFFFFF 0%, #EDEDED 100%)',
        width: '100%',
        overflow: 'hidden',
        boxShadow: shadows.lightBox,
        ...props.sx,
      }}>
      <Grid container direction="column" sx={{ height: '100%' }}>
        <Grid item display="flex" flexGrow="1" justifyContent="center" bgcolor="#FDA9FF">
          <img src={FamiliplusLongVersion} width={'290px'} alt="Familiplus" />
        </Grid>
        <Grid item display="flex" height="64.90px" bgcolor="#002C50" paddingX="30px" paddingY="8.45px">
          <Grid container justifyContent="space-between" sx={{ height: '100%' }}>
            <Grid item sx={{ height: '100%', color: '#FDA9FF' }} display="flex" alignItems="center">
              <Grid container direction="column">
                <Grid item>
                  <Body>{t('cardMember.rewards')}</Body>
                </Grid>
              </Grid>
            </Grid>
            <Grid item sx={{ height: '100%', color: '#FFF' }} display="flex" alignItems="center">
              <Grid container direction="column">
                <Grid item>
                  <H6 data-cy="numberOfPoints">
                    <strong>{t('cardMember.nbrPointsShort', { count: props.numberOfPoints })}</strong>
                  </H6>
                </Grid>
                <Grid item>
                  <Body data-cy="pointsValue">{t('cardMember.valueOfPoints', { amount: pointsValue })}</Body>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default FamiliplusProfileCard;
